import { useEffect, useRef } from 'react';

// Llama `save` `delay` ms después del último cambio de `deps`. Los valores que llegan mientras
// `ready` es false (carga inicial) no se guardan. Al desmontar se ejecuta el guardado pendiente.
export function useAutosave(save, deps, ready, delay = 500) {
  const timer   = useRef(null);
  const pending = useRef(null);
  const skip    = useRef(true);

  useEffect(() => {
    if (!ready) { skip.current = true; return; }
    if (skip.current) { skip.current = false; return; }
    pending.current = save;
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      const fn = pending.current;
      pending.current = null;
      fn?.();
    }, delay);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready, ...deps]);

  useEffect(() => () => {
    clearTimeout(timer.current);
    pending.current?.();
  }, []);
}
